import { useContext, useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { Tabs } from '@mantine/core'
import { StationDetailsPage } from '@/pages/stations/details/station-details.page'
import { StationContext } from '@/pages/stations/station-context'
import { StationWoolDataPage } from '@/pages/stations/wool-data/station-wool-data.page'
import { StationOffers } from '@/pages/stations/offers/station-offers.page'
import { StationSpeciPage } from '@/pages/stations/speci/station-speci.page'
import { useNavigation } from '@/hooks/use-navigation'

export enum StationTabValue {
  DETAILS = 'details',
  SPECIFICATIONS = 'speci',
  OFFERS = 'offers',
  WOOL_DATA = 'wool-data',
}

export function StationPage() {
  const station = useContext(StationContext)
  const { stationTabValue } = useParams()
  const { navigateToStationDetails, navigateToStationTab } = useNavigation()

  // If root station route, redirect to details panel by default
  useEffect(() => {
    if (station?.recordNumber && stationTabValue === undefined) {
      navigateToStationDetails(station.recordNumber)
    }
  }, [station?.recordNumber, stationTabValue])

  return (
    <Tabs
      keepMounted={false}
      defaultValue={StationTabValue.DETAILS}
      value={stationTabValue}
      onChange={(value) => navigateToStationTab(station?.recordNumber, value)}
    >
      <Tabs.List mb='md'>
        <Tabs.Tab value={StationTabValue.DETAILS}>Details</Tabs.Tab>
        <Tabs.Tab value={StationTabValue.SPECIFICATIONS}>Speci</Tabs.Tab>
        <Tabs.Tab value={StationTabValue.OFFERS}>Offers</Tabs.Tab>
        <Tabs.Tab value={StationTabValue.WOOL_DATA}>Wool data</Tabs.Tab>
      </Tabs.List>

      <Tabs.Panel value={StationTabValue.DETAILS}>
        <StationDetailsPage />
      </Tabs.Panel>
      <Tabs.Panel value={StationTabValue.SPECIFICATIONS}>
        <StationSpeciPage />
      </Tabs.Panel>
      <Tabs.Panel value={StationTabValue.OFFERS}>
        <StationOffers />
      </Tabs.Panel>
      <Tabs.Panel value={StationTabValue.WOOL_DATA}>
        <StationWoolDataPage />
      </Tabs.Panel>
    </Tabs>
  )
}
